import { render, staticRenderFns } from "./CheckboxSimple.vue?vue&type=template&id=1d5aab3a&"
import script from "./CheckboxSimple.vue?vue&type=script&lang=js&"
export * from "./CheckboxSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports